// extracted by mini-css-extract-plugin
export default {"fourOhFourContainer":"fourOhFourNotFoundPage_fourOhFourContainer__hM8Xt"};